<template>
  <div class="bg-container page">
    <img class="bg-img" src="/img/login-bg.png" alt="" />
    <div class="bg-wrapper">
      <div class="login">
        <van-nav-bar class="nav-bar">
          <template #left>
            <van-icon name="arrow-left" color="#d7d7d7" size="22" @click="goBack" />
          </template>
          <template #right>
            <div class="language" @click="showLangSheet = true">
              <img :src="currentLangFlag" alt="" />
            </div>
          </template>
        </van-nav-bar>

        <van-popup
          v-model="showLangSheet"
          position="bottom"
          round
          class="lang-popup"
          :overlay-style="{ background: 'rgba(0, 0, 0, 0.65)' }"
        >
          <div class="lang-panel">
            <div class="lang-panel-header">
              <span class="lang-panel-title">{{ $t("setting.language") }}</span>
              <van-icon name="cross" color="#ff7186" @click="showLangSheet = false" />
            </div>
            <div
              v-for="item in langOptions"
              :key="item.value"
              class="lang-item"
              :class="{ active: lang === item.value }"
              @click="changeLang(item.value)"
            >
              <div class="lang-item-left">
                <img :src="item.flag" class="lang-item-flag" alt="" />
                <span>{{ item.name }}</span>
              </div>
              <van-icon v-if="lang === item.value" name="success" color="#ff7186" />
            </div>
          </div>
        </van-popup>

        <div class="wrapper">
          <div class="logo-container">
            <div class="logo-wrapper">
              <img class="logo-img" :src="logoSrc" alt="logo" @error="onLogoError" />
            </div>
          </div>

          <div class="loginForm">
            <van-field
              v-model="username"
              class="input"
              input-align="center"
              :placeholder="$t('auth.username_place')"
            />
            <van-field
              v-model="password"
              class="input"
              input-align="center"
              :type="passwordType"
              :placeholder="$t('auth.pwd_place')"
            >
              <template #right-icon>
                <van-icon
                  :name="passwordType === 'password' ? 'closed-eye' : 'eye-o'"
                  color="#ff7186"
                  @click="switchPasswordType"
                />
              </template>
            </van-field>

            <div class="register-text" @click="toRegister">
              <span>{{ $t("auth.no_account") }}</span>
            </div>

            <van-button class="login-btn" type="primary" @click="doLogin">
              {{ $t("auth.login") }}
            </van-button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import { LANG_OPTIONS, getStoredLang } from "../../utils/lang";

export default {
  data() {
    return {
      username: "",
      password: "",
      passwordType: "password",
      lang: getStoredLang(),
      showLangSheet: false,
    };
  },
  computed: {
    ...mapState(["baseInfo"]),
    langOptions() {
      return LANG_OPTIONS;
    },
    currentLangFlag() {
      const item = this.langOptions.find((o) => o.value === this.lang);
      return item ? item.flag : LANG_OPTIONS[0].flag;
    },
    logoSrc() {
      const ico = this.baseInfo && this.baseInfo.ico;
      if (ico) {
        if (/^https?:\/\//i.test(ico)) return ico;
        if (process.env.NODE_ENV === "development") {
          return ico.startsWith("/") ? ico : `/${ico}`;
        }
        return ico.startsWith("/")
          ? `https://api.t9299.top${ico}`
          : `https://api.t9299.top/${ico}`;
      }
      return "/img/app-logo.png";
    },
  },
  mounted() {
    this.lang = getStoredLang();
  },
  methods: {
    onLogoError(e) {
      if (e && e.target) e.target.src = "/img/app-logo.png";
    },
    goBack() {
      if (window.history.length > 1) this.$router.back();
      else this.$router.replace("/Home");
    },
    switchPasswordType() {
      this.passwordType =
        this.passwordType === "password" ? "text" : "password";
    },
    toRegister() {
      this.$router.push("/Register");
    },
    changeLang(lang) {
      if (lang === this.lang) {
        this.showLangSheet = false;
        return;
      }
      this.lang = lang;
      this.$i18n.locale = lang;
      localStorage.setItem("lang", lang);
      this.showLangSheet = false;
      this.$http({ method: "get", url: "replaceLang", data: { lang } });
    },
    doLogin() {
      if (!this.username.trim()) {
        this.$toast(this.$t("auth.username_place"));
        return;
      }
      if (!this.password.trim()) {
        this.$toast(this.$t("auth.pwd_place"));
        return;
      }
      this.$http({
        url: "member_login",
        method: "get",
        data: {
          username: this.username,
          password: this.password,
          lang: this.lang,
        },
      }).then((res) => {
        if (res.code === 200) {
          this.$toast.success(res.msg);
          localStorage.setItem("token", res.data.id);
          this.$router.replace("/Home");
        } else {
          this.$toast(res.msg);
        }
      });
    },
  },
};
</script>

<style lang="less" scoped>
.bg-container {
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
  z-index: 2;
  background: #fff;
  overflow: hidden;
}

.bg-img {
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
}

/* 与参考站完全一致：顶部透明 → 底部 #ff7186 */
.bg-wrapper {
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
  background: linear-gradient(rgba(255, 255, 255, 0), rgb(255, 113, 134));
}

.login {
  position: relative;
  height: 100%;
  overflow: hidden;
  background: transparent;
}

.nav-bar {
  background: transparent !important;

  /deep/ .van-nav-bar,
  /deep/ .van-nav-bar__content {
    background: transparent !important;
  }

  /deep/ .van-hairline--bottom::after {
    border: none !important;
  }
}

.language {
  position: relative;
  height: 10.667vw;
  display: flex;
  align-items: center;
  padding-right: 1vw;

  img {
    height: 100%;
    width: auto;
    border-radius: 50%;
    object-fit: cover;
  }
}

.wrapper {
  height: calc(100% - 46px);
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
}

.logo-container {
  margin: 0 auto;
  width: 45%;
}

.logo-wrapper {
  position: relative;
  padding-bottom: 62.5%;
}

.logo-img {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  object-fit: contain;
  opacity: 0.8;
}

.loginForm {
  padding: 8vw;
}

/deep/ .input {
  padding: 1.333vw 2.667vw !important;
  margin-top: 5.333vw;
  border-radius: 6.667vw !important;
  background-color: rgba(0, 0, 0, 0.5) !important;
  border: none !important;
  color: #ff7186;

  .van-field__control {
    color: #fff !important;
    font-size: 3.2vw;
    text-align: center;
    height: 10.667vw;
    line-height: 10.667vw;

    &::placeholder {
      color: rgba(255, 255, 255, 0.8);
    }
  }

  .van-field__right-icon .van-icon {
    font-size: 6.667vw !important;
    color: #ff7186 !important;
  }
}

/deep/ .van-cell::after {
  display: none;
}

.register-text {
  margin: 5.333vw 0 0;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;

  span {
    color: #fff;
    font-size: 3.333vw;
    font-weight: 500;
    line-height: 2.667vw;
  }
}

.login-btn {
  margin-top: 11.333vw;
  width: 100%;
  height: 13.333vw;
  border: none !important;
  border-radius: 6.667vw !important;
  font-size: 3.2vw;
  font-weight: 700;
  background: linear-gradient(90deg, #ff8395, #ff556e) !important;
  color: #fff !important;
}

.lang-popup {
  background: transparent;
}

.lang-panel {
  background: linear-gradient(180deg, #2b2b2b 0%, #1a181a 100%);
  border-radius: 28px 28px 0 0;
  padding: 28px 30px calc(40px + env(safe-area-inset-bottom));
}

.lang-panel-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 24px;
}

.lang-panel-title {
  color: #ff7186;
  font-size: 34px;
  font-weight: 600;
}

.lang-item {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 24px;
  margin-bottom: 16px;
  border-radius: 16px;
  background: rgba(255, 255, 255, 0.04);
  color: #f3c7a2;
  font-size: 28px;

  &.active {
    border: 1px solid #ff7186;
  }
}

.lang-item-left {
  display: flex;
  align-items: center;
  gap: 18px;
}

.lang-item-flag {
  width: 48px;
  height: 48px;
  border-radius: 50%;
  object-fit: cover;
}
</style>
